import { FC } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { useQueryParams, useRouteParams } from "app/route/route";
import { editReportVersionRoute, reportVersionTransitionRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useReportVersionQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { TransitionReportVersionForm } from "app/component/report-version/TransitionReportVersionForm";

export const TransitionReportVersionScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionTransitionRoute);
    const { transition } = useQueryParams(reportVersionTransitionRoute);
    const { data, loading, error } = useReportVersionQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const reportVersion = data?.reportVersion;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!reportVersion) {
        return <ErrorScreen title="Error" message="Not found" />;
    }
    if (transition == null || !reportVersion.transitions?.includes(transition)) {
        return <Navigate to={editReportVersionRoute.build({ reportId, versionId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionTransitionRoute} />
                <h1>{reportVersion.report.title}</h1>
                <h2>
                    {reportVersion.versionName} ({reportVersion.versionNumber})
                </h2>
                <TransitionReportVersionForm reportVersionId={versionId} transition={transition} />
            </Container>
        </NavigationScreen>
    );
};
